module.exports = __webpack_public_path__ + "static/media/felaWealth.71008786.jpg";